import BaseModel from './BaseModel';
import Vue from 'vue';

export default class FormBaseModel extends BaseModel {
  constructor(data = {}) {
    super(data);

    this.__errors = {};
  }

  get errors() {
    return {
      set: (errors) => {
        this.__errors = _.isPlainObject(errors) ? errors : {};
      },
      has: (error) => {
        return error in this.__errors;
      },
      list: (error) => {
        return this.errors.has(error) ? this.__errors[error] : [];
      },
      remove: (error) => {
        Vue.delete(this.__errors, error);
      },
    };
  }
}
